import React from 'react';

import { useSelector } from 'react-redux';
import { t } from 'react-switch-lang';
import ContactUsPaySimply from './ContactUsPaySimply';
import ContactUsZenwallet from './ContactUsZenwallet';
import { DocumentTitle } from '../../../helperFunctions/DocumentTitle';
import { brandTitleGet } from '../../../configurations/Brands';
import ContactUsPartners from './ContactUsPartners';
import ContactUsPayments from './ContactUsPayments';
import NotFound from '../NotFound';

function ContactSorter() {
  const { brand, lang } = useSelector((state) => state);
  DocumentTitle(
    t('PageTitle_Brand_Contact').replace('xBrand', brandTitleGet(brand, lang))
  );
  const contactList = {
    paysimply: <ContactUsPaySimply lang={lang} />,
    zenwallet: <ContactUsZenwallet lang={lang} />,
    partners: <ContactUsPartners lang={lang} />,
    payments: <ContactUsPayments lang={lang} />,
  };

  return contactList[brand] || <NotFound brand={brand} lang={lang} />;
}

export default ContactSorter;
